<template>
  <h1 class="seo-heading"><span v-if="heading.prefix" class="seo-heading__context">{{ heading.prefix }}</span><span>{{ heading.name }}</span><span v-if="heading.suffix" class="seo-heading__context">{{ heading.suffix }}</span></h1>
</template>

<script>
import { getPage } from '@/seo/pages'

export default {
  name: 'SeoHeading',
  computed: {
    heading () {
      const page = getPage(this.$route.path)
      return page.heading || { name: page.h1 || page.name }
    }
  }
}
</script>
